export default {
  aggregates: {
    aggregated: 'Kokonaistulokset',
    aggregatedDate: '{startDate} - {fromDate}',
    ago: 'sitten',
    from: 'alkaen',
    since: 'lähtien',
    unit: {
      DAY: 'päivä | päivää',
      MONTH: 'kuukausi | kuukautta',
      YEAR: 'vuosi | vuotta'
    },
    untilNow: 'tähän saakka'
  },
  categoryDetails: {
    average: 'Keskiarvo:',
    chartLabel: {
      noLabel: 'Ei',
      yesLabel: 'Kyllä'
    },
    description:
      'Tämä näyttää, miten tiimin vastaukset jakautuvat jokaisen kysymysen osalta.',
    hideOwnAnswers: 'Piilota omat vastaukset',
    noResponses: 'Ei vastauksia',
    notParticipating: 'Et ole itse vastannut näihin kysymyksiin.',
    numberOfPeople: 'Vastaajat:',
    sensitiveQuestion: 'Vain sinun nähtävissäsi, koska olet esimies.',
    showFollowUpQuestions: 'Näytä jatkokysymykset',
    toggleButton: {
      overview: 'Yleiskatsaus',
      questions: 'Kysymykset'
    },
    tooltip: {
      barValue: 'ei yhtään | {count} henkilö | {count} henkilöä',
      barValueAnswers: 'ei ketään| {count} vastaus | {count} vastausta'
    },
    workWith: 'Paranna {categoryName}',
    yourResponse: 'Vastasit:'
  },
  error: {
    couldNotLoadAggregates: 'Kokonaistuloksia ei voitu ladata.',
    couldNotLoadResults: 'Tuloksia ei voitu ladata.',
    networkError:
      'Tietoja Internetistä ladattaessa oli ongelma. Onko sinulla toimiva nettiyhteys?',
    unknown: 'Tuntematon virhe'
  },
  errors: {
    status: {
      BadRequest: 'Huono pyyntö palvelimelle',
      Forbidden: 'Tähän resurssiin ei ole pääsyoikeutta',
      InternalServerError:
        'Jokin meni vikaan palvelimessa. Ota yhteys tukeen, mikäli ongelma jatkuu',
      NotFound: 'Emme löytäneet etsimääsi',
      Unauthorized: 'Sinulla ei ole pääsyoikeutta tähän resurssiin',
      UnknownError: 'On tapahtunut tuntematon virhe'
    }
  },
  freetext: {
    loadResponses: 'Lataa vastauksia',
    noFreeTextQuestions:
      'Kun kyselyssä on vapaan tekstin kysymyksiä, voit nähdä kaikki vastaukset tässä.',
    notEnoughResponses: 'Ei tarpeeksi vastauksia.',
    responses: 'Ei vastauksia |{count} vastaus | {count} vastausta'
  },
  general: {
    add: 'Lisää',
    cancel: 'Peruuta',
    entireOrganization: 'Koko organisaatio',
    ok: 'Ok'
  },
  groupsComparison: {
    averageForItem:
      '{value} on kohdan {title} kysymysten keskiarvo. {compareToBenchmark}',
    currentValue: 'Nykyinen arvo',
    filter: {
      findGroups: 'Etsi ryhmiä',
      shouldExportWithHierarchy: 'Sisältää taustalla olevat ryhmät'
    },
    loadMore: 'Lataa lisää',
    loadMoreInGroup: 'Lataa lisää nimellä {groupName}',
    noone: 'Kukaan ei ole vastannut',
    noResults:
      'Tältä ryhmältä ei ole vielä saatu riittävästi vastauksia. {numberOfUsersThatHaveRespondedText}.',
    noResultsResponded: 'on vastannut',
    nps: 'Suositteluindeksi',
    nps_detractors: 'Kriitikot',
    nps_passives: 'Passiiviset',
    nps_promoters: 'Suosittelijat',
    questions: 'Kysymykset kategoriassa',
    showTrend: 'Näytä muutos',
    violationsIn:
      'Vastausten mukaan ryhmässä {groupName} on tehty rikkomuksia. Ota yhteyttä henkilöstöosastoon, niin saat lisätietoja ja apua asian selvittämiseen tulevaisuudessa.'
  },
  history: {
    selectorDescriptions: {
      noCustomDateSelected: 'Valitse historian aloituspisteen päivämäärä.',
      selectDate: 'Voi näyttää kyselyhistorian alkaen päivästä {date}.',
      selectedDate: 'Näyttää kyselyhistorian alkaen päivästä {date}.'
    },
    selectorOptions: {
      custom: 'mukautettu',
      oneMonth: '1m',
      oneYear: '12m',
      sixMonths: '6m'
    }
  },
  loading: {
    error: {
      link: 'Yritä uudelleen'
    }
  },
  navbar: {
    administration: 'Ylläpito',
    currentSurveys: 'Nykyiset kyselyt',
    help: 'Ohjeet',
    myActivities: 'Toimenpiteet',
    ourResults: 'Tulokset',
    overview: 'Yleiskatsaus',
    team: 'Tiimi',
    welcome: 'Tervetuloa'
  },
  page: {
    results: 'Kaikki tulokset'
  },
  resultDetails: {
    backToResults: 'Takaisin',
    exportData: 'Vie',
    exportModal: {
      includeSensitiveQuestions: 'Sisällytä arkaluonteiset kysymykset',
      loadingMessage: 'Tietojen viemistä valmistellaan. Odota hetki!',
      saveAsExcelAllGroupsDescription:
        'Kun viet Exceliin, saat tiedoston, jossa on tulokset ryhmälle {groupTitle} ja kaikille taustalla oleville ryhmille... Tämä on hyvä, jos haluat tehdä omia monen ryhmän analyyseja tai laskelmia.',
      saveAsExcelButton: 'Excel',
      saveAsExcelDescription:
        'Kun viet Exceliin, saat tiedoston, jossa on tulokset ryhmälle {groupTitle}{segmentInfo}. Tämä on hyvä, jos haluat tehdä omia analyyseja tai laskelmia.',
      saveAsPdfButton: 'PDF',
      saveAsPdfDescription:
        'Saat PDF-asiakirjan, jossa on tulokset kaikille kategorioille ja kysymykset valitulle ryhmälle. Se on hyödyllinen, kun haluat tulostaa tulokset.',
      saveAsPowerPointButton: 'PowerPoint',
      saveAsPowerPointDescription:
        'PowerPoint-viennillä saat hyvän esittelyn tuloksista ryhmälle {groupTitle}{segmentInfo}. Se on täydellinen, kun haluat näyttää tuloksia muille suurella näytöllä.'
    },
    notes: {
      draggable: {
        explanation: 'Näkyy vain sinulle',
        placeholder:
          'Kirjoita tähän omat muistiinpanosi, kommentit ja pohdinnat kyselystä',
        title: 'Henkilökohtaiset muistiinpanot'
      },
      status: {
        initial: 'Tallennetaan automaattisesti kirjoittaessasi',
        saved: 'Muutokset tallennettu!',
        unsaved: 'Tallennetaan pian...'
      }
    },
    tagDetails: {
      color: {
        alerts: {
          notEnoughResponses:
            'Vastauksia ei ole riittävästi käyttäjäkohtaisten tulosten näyttämiseksi'
        },
        description: {
          high: 'Yksi henkilö vastasi, joten hänen keskimääräinen tuloksensa muuttui vihreäksi.|{count} henkilöä vastasi, joten heidän keskimääräinen tuloksensa muuttui vihreäksi.',
          low: 'Yksi henkilö vastasi, joten hänen keskimääräinen tuloksensa muuttui punaiseksi.|{count} henkilöä vastasi, joten heidän keskimääräinen tuloksensa muuttui punaiseksi.',
          medium:
            'Yksi henkilö vastasi, joten hänen keskimääräinen tuloksensa muuttui keltaiseksi.|{count} henkilöä vastasi, joten heidän keskimääräinen tuloksensa muuttui keltaiseksi.'
        },
        title: 'Ei kukaan|Yksi henkilö|{count} henkilöä'
      },
      currentValue: {
        equalsToBenchmarkValue:
          'Tuloksesi on sama kuin Pulsᐩ benchmark® kohteelle {title}.',
        higherThanBenchmarkValue:
          'Tuloksesi on {benchmarkDiff} korkeampi kuin Pulsᐩ benchmark® kohteelle {title}, joka on {benchmarkValue}. Hienoa!',
        lowerThanBenchmarkValue:
          'Olet {benchmarkDiff} alempana kuin Pulsᐩ benchmark® kohteelle {title}, joka on {benchmarkValue}',
        percentagePoints: 'prosenttiyksikköä'
      },
      enps: {
        button: {
          description:
            'Sinut ohjataan kumppanillemme, EQI, joka kerää suorituskyvyn mittaustietoja suuresta määrästä organisaatioita ja selittää yksityiskohtaisemmin oman eNPS-tuloksesi.',
          title: 'Vertaa eNPS-tulostasi muihin organisaatioihin'
        }
      },
      toggleButton: {
        history: 'Historia',
        overview: 'Yleiskatsaus'
      }
    }
  },
  results: {
    aggregated: 'Kertynyt',
    chooseSurvey: 'Valitse kysely',
    finished: 'Valmis',
    published: 'Meneillään oleva'
  },
  resultsmessages: {
    disclaimer:
      'Pulsᐩ AI käyttää generatiivista tekoälyä ja voi tehdä virheitä.',
    error: {
      generic:
        'Voi ei... jokin ei toiminut odotetulla tavalla. Yritä ladata sivu uudelleen.',
      notEnoughResults:
        'Tuloksia ei ole. Valitse eri ryhmä tai kysely käyttääksesi Pulsᐩ AI:ta.'
    },
    moreInfo: 'Katso, miten käytät Pulsᐩ AI:ta johtajana',
    moreInfoLink: 'https://www.puls-solutions.com/help/#/section/1/articles/10',
    placeholder: 'Kysy kysymys tuloksista...',
    reload: 'Lataa sivu uudelleen',
    report: 'Ilmoita ongelmasta',
    send: 'Lähetä',
    suggestionHeader: 'Tässä on muutamia kysymyksiä, joita voit esittää:',
    suggestions: {
      groupsComparison: {
        1: 'Mihin ryhmiin minun pitäisi keskittyä?',
        2: 'Onko jotain kysymystä, jonka parissa useimpien ryhmien tulisi työskennellä?',
        3: 'Mitkä ryhmät osoittavat negatiivisia suuntauksia?',
        4: 'Millä ryhmillä on myönteisiä suuntauksia?',
        5: 'Mitkä ryhmät erottuvat negatiivisesti?',
        6: 'Mitkä ryhmät tarvitsevat huomiotani?',
        7: 'Mitä minun pitäisi tehdä ensin?'
      },
      overview: {
        1: 'Mitä minun tulisi tehdä tuloksellamme?',
        2: 'Miten minun tulisi esitellä tulos tiimilleni?',
        3: 'Miltä tulokset näyttävät yleisesti ottaen?',
        4: 'Mitkä ovat kolme tärkeintä toimenpidettä, joihin meidän pitäisi ryhtyä?',
        5: 'Mitä voin parantaa johtajuudessani?',
        6: 'Mitä riskejä meillä on?',
        7: 'Mitä voi tapahtua, jos emme toimi?',
        8: 'Mitä minun pitäisi priorisoida?',
        9: 'Mikä on tiimini ennuste?'
      }
    },
    title: 'Pulsᐩ AI'
  },
  resultsPerAttribute: {
    attributes: {
      all: {
        title: 'Kaikki'
      }
    }
  },
  sections: {
    resultsForSurvey: {
      tabs: {
        compare: {
          title: 'Vertaa'
        },
        export: {
          title: 'Vie'
        },
        freetext: {
          title: 'Vapaa teksti'
        },
        results: {
          title: 'Kyselyn tulokset'
        }
      }
    }
  },
  segmentedDetails: {
    notEnoughResponses:
      'Tilastojen esittäminen ilman anonymiteetin menettämisen riskiä ei ole mahdollista.',
    others: 'Muu | Muut',
    tooltip: {
      barValue: '{numberOfPeople} {segment}'
    }
  },
  sidebar: {
    administration: 'Hallinnointi',
    currentSurveys: 'Nykyiset kyselyt',
    dashboard: 'Ohjausnäkymä',
    help: 'Ohje',
    logOut: 'Kirjaudu ulos',
    myActivities: 'Oma toiminta',
    ourResults: 'Tuloksemme'
  },
  topbanner: {
    preview: {
      body: 'Näet nyt Pulsᐩ-tulosnäkymän uuden version, jossa on paljon parannuksia! Jos huomaat jotakin, mikä ei toimi odotetulla tavalla tai haluat antaa palautetta, kerro meille siitä! Voit myös halutessasi vaihtaa vanhaan versioon.',
      header: 'Uusi versio!'
    }
  },
  trendArrow: {
    category: {
      tooltip: {
        trend_decreased:
          'Aikajaksolla {startDate} - {endDate} tulos on pienentynyt kohteelle {categoryName}.',
        trend_increased:
          'Aikajaksolla {startDate} - {endDate} tulos on kasvanut kohteelle {categoryName}. Jatka hyvää työtä!',
        trend_same:
          'Tulos on pysynyt samana {categoryName} ajanjaksolla {startDate} - {endDate}.'
      }
    },
    noTrend: 'Vertailtavaa vanhempaa kyselyä ei ole.',
    tag: {
      tooltip: {
        nps_trend_decreased:
          'Edelliseen kyselyyn ({oldSurveyDate}) verrattuna kohteen {tagName} tulos on laskenut {changeInPercent} prosenttia.',
        nps_trend_increased:
          'Edelliseen kyselyyn ({oldSurveyDate}) verrattuna kohteen {tagName} tulos on noussut {changeInPercent} prosenttia.',
        nps_trend_same:
          'Edelliseen kyselyyn ({oldSurveyDate}) verrattuna tulos on pysynyt suunnilleen samana kohteelle {tagName} ({changeInPercent} % muutos)',
        trend_decreased:
          'Aikajaksolla {startDate} - {endDate} tulos on pienentynyt kohteelle {tagName}.',
        trend_increased:
          'Aikajakson {startDate} - {endDate} aikana tulos on kasvanut kohteelle {tagName}',
        trend_same:
          'Tulos on pysynyt samana {categoryName} ajanjaksolla {startDate} - {endDate}.'
      }
    }
  },
  utilityBar: {
    allGroups: 'Kaikki ryhmät',
    cannotChangeGroupsWhileComparing:
      'Vertailunäkymässä voit katsoa useita ryhmiä samaan aikaan.',
    group: 'Ryhmä',
    segment: 'Segmentti',
    survey: 'Kysely'
  },
  widgetActionsSummary: {
    labels: {
      peopleThatSelectedAnAction:
        'Vähintään yhden toimenpiteen valinneiden ihmisten määrä',
      totalActions: 'Valittujen toimenpiteiden kokonaismäärä'
    },
    title: 'Yhteenveto toiminnoista'
  },
  widgetAlert: {
    actions: {
      saved: 'Kiitoksia. Toiminta on tallennettu.'
    },
    links: {
      tooltip: 'Linkki avautuu seuraavassa ikkunassa'
    },
    notEnoughData: 'Näytettäviä tuloksia ei ole.'
  },
  widgetCategoriesBars: {
    aggregateInfo: {
      harassment: {
        info: 'Viimeisin ilmoitettu {surveyDate}.'
      },
      question: {
        info: 'Viimeisin kysytty {surveyDate} kohdassa "{surveyTitle}".'
      }
    },
    notEnoughResponses:
      'Vastauksia ei ole vielä tarpeeksi, jotta tässä voisi näyttää tuloksia.',
    title: 'Kategoriat',
    tooltip: {
      value:
        'Tämä on keskiarvo ryhmän {groupName} vastauksille kategorian {categoryName} kysymyksiin.'
    }
  },
  widgetErrorFallback: {
    description:
      'On tapahtunut odottamaton virhe widgetin lataamisen aikana. Yritä ensin ladata sivu uudelleen. Jos ongelma jatkuu, ilmoita ongelmasta meille, ja yritämme selvittää sen heti!',
    hideErrorDetails: 'Piilota virhetiedot',
    showErrorDetails: 'Näytä virhetiedot',
    title: 'Ongelma widgetissä!'
  },
  widgetGroupActions: {
    allCategories: 'Kaikissa kategorioissa',
    freeText: {
      alert: {
        noResults: 'Mitään ei löytynyt. Yritä kirjoittaa jotain muuta.',
        typeMore: 'Kirjoita lisää'
      },
      filterField: {
        placeholder: 'Kirjoita etsiäksesi kommentteja'
      },
      numberOfComments: '{numberOfComments} kommenttia'
    },
    links: {
      guide: {
        link: 'https://player.vimeo.com/video/887258169',
        title:
          'Miten kehittää henkilökohtaista vastuuta työntekijöiden keskuudessa'
      }
    },
    noActions: 'Ei näytettäviä toimenpiteitä.',
    noActionsSelectedInCategory: 'Et ole valinnut toimintoja',
    otherActions: 'Omat toimenpiteet',
    people: 'ei yhtään | {count} henkilö | {count} henkilöä',
    peopleSelectedActions:
      '{peopleResponded} vastanneesta vain yksi on valinnut ainakin yhden toiminnon ({percentage}%)| {peopleResponded} vastanneesta {count} henkilöstä valitsi ainakin yhden toiminnon ({percentage}%)',
    title: 'Valitut toimenpiteet ryhmään {groupName} kuuluville ihmisille',
    tooltip: {
      numberOfPeopleChoseActions:
        '1 henkilö on valittu tähän toimintoon | {count} henkilöä on valittu tähän toimintoon'
    }
  },
  widgetGroupPriorities: {
    description:
      'Nämä ovat tällä hetkellä tärkeimpiä huomiota vaativia alueita kyselyyn osallistuneiden mielestä.',
    freeTextResponses: 'Näytä avoimet vastaukset',
    links: {
      guide: {
        link: 'https://player.vimeo.com/video/887214144',
        title: 'Kuinka kehität tiimiäsi Pulsᐩ:n avulla'
      }
    },
    noPriorities: 'Osallistujat eivät valinneet tärkeysjärjestystä.',
    people: 'ei yhtään | {count} henkilö | {count} henkilöä',
    thinkImportant: ' ajattelee, että "{category}" on tärkein',
    title: 'Etusijalla osallistujille ryhmässä {groupName}'
  },
  widgetNotImplemented: {
    content: 'Ei vielä otettu käyttöön'
  },
  widgetSurveyInfo: {
    endDate: 'Päättymispäivä:',
    noone: 'Kukaan ei ole vastannut',
    notEnoughResponses: {
      aggregate:
        'Tuloksia ei voi näyttää, koska liian vähän henkilöitä vastasi aikajakson sisällä.',
      completed:
        'Tuloksia ei voi näyttää, koska liian vähän henkilöitä vastasi kyselyyn.',
      published:
        'Tuloksia ei voi näyttää, koska kyselyyn ei ole vielä vastannut tarpeeksi monta henkilöä.'
    },
    participation: {
      title: 'Osallistuminen'
    },
    startDate: 'Aloituspäivä:',
    status: {
      completed: 'Kysely on valmis! Tässä ovat lopulliset tulokset.',
      published: 'Kysely on yhä käynnissä. Tulokset ovat alustavia.'
    },
    usersInvited: 'Kutsutut henkilöt:',
    usersResponded: 'Vastanneet henkilöt:'
  },
  widgetTagsDonuts: {
    description: {
      all: 'Nämä ovat uusimmat tulokset ryhmälle {groupName}.'
    },
    notEnoughResponses:
      'Vastauksia ei ole vielä tarpeeksi, jotta tässä voisi näyttää tuloksia.',
    title: {
      company: 'Koko {organizationName}'
    },
    tooltip: {
      enps_description:
        'eNPS tulee termistä "Employee Net Promoter Score" ja se mittaa, kuinka todennäköisesti työntekijät suosittelevat yritystään työnantajana.',
      nps_description:
        'NPS tarkoittaa suositteluindeksiä ("Net Promoter Score"), ja se mittaa, kuinka todennäköisesti henkilöt suosittelevat jotain toisille ihmisille.',
      nps_detractors: 'Kriitikot',
      nps_passives: 'Passiiviset',
      nps_promoters: 'Suosittelijat',
      value:
        'Tämä on keskiarvo ryhmän {groupName} vastauksille tunnisteella {tagName} varustettuihin kysymyksiin.'
    }
  },
  widgetTagsTrends: {
    title: '{tagNames} ajan kuluessa',
    twoTags: '{tag1} ja {tag2}'
  }
}
